import { faChartBar,  faEnvelope,  faHamburger, faHomeAlt,  faSignOut,  faUniversity} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import './Admin.css'
import AdminHome from "../Admin-home/Admin-home";
import ManageRequest from "../ManageRequest/ManageRequest";
import AddCompany from "../../components/AddCompany/AddCompany";
import Statistics from "../Statistics/Statistics";
const AdminDashboard = () => {
 
  const [activeItem, setActiveItem] = useState("");
  const [userData, setUserData] = useState(null);
  const [page, setPage] = useState(null);
  const [navCollapse, setNavCollapse] = useState(false);
  const [smallNavCollapse, setSmallNavCollapse] = useState(false);

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);
    setActiveItem("home");
    setPage(<AdminHome />); // Set the default page to AdminHome
  }, []);

  // Removed unused handlePageChange function

  const page1 = () => {
    if (activeItem !== "home") {
      setActiveItem("home");
      setPage(<AdminHome/>);
    }
  };

  const page2 = () => {
    setActiveItem("request");
    setPage(<ManageRequest/>);
  };



  const page3 = () => {
    setActiveItem("Institutions");
    setPage(<AddCompany/>);
  };

  const page4 = () => {
    setActiveItem("Statistics");
    setPage(<Statistics/>);
  };

 

  const handleLogout = () => {
    // Clear the session
    localStorage.clear();

    // Redirect the user to the login page
    window.location.href = '/'; // Replace with your desired URL
  };
  return (
    <>
      <div className="nav-container">
        <nav className="nav">
          <div className="s2-logo">
            <h3>Intern Buddy</h3>
            <FontAwesomeIcon
              className="LargeDevice-icon"
              icon={faHamburger}
              onClick={(e) => setNavCollapse(!navCollapse)}
            ></FontAwesomeIcon>
            <FontAwesomeIcon
              className="smallDevice-icon"
              icon={faHamburger}
              onClick={(e) => setSmallNavCollapse(!smallNavCollapse)}
            ></FontAwesomeIcon>
          </div>
        </nav>
        <div className="pg-content">
          <div className="nav-sidebar-content">
            <div
              className={`${
                smallNavCollapse ? " smallNav " : ""
              } nav-sidebar-container ${navCollapse ? " navCollapse" : ""}`}
            >
              <div
                className={`nav-option option1 ${
                  activeItem === "home" ? "active" : ""
                }`}
                onClick={page1}
              >
                <FontAwesomeIcon icon={faHomeAlt}></FontAwesomeIcon>
                <h3>Home</h3>
              </div>
              <div
                className={`nav-option option1 ${
                  activeItem === "request" ? "active" : ""
                }`}
                onClick={page2}
              >
                <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon>
                <h3>Request</h3>
              </div>
              <div
                className={`nav-option option1 ${
                  activeItem === "Institutions" ? "active" : ""
                }`}
                onClick={page3}
              >
                <FontAwesomeIcon icon={faUniversity}></FontAwesomeIcon>
                <h3>Institutions</h3>
              </div>
              <div
                className={`nav-option option1 ${
                  activeItem === "Statistics" ? "active" : ""
                }`}
                onClick={page4}
              >
                <FontAwesomeIcon icon={faChartBar}></FontAwesomeIcon>
                <h3>Statistics</h3>
              </div>
              
              <div className="nav-option option1">
                <h3>{userData && userData.userData.name}</h3>
              </div>
              <div className="nav-option option1" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOut}></FontAwesomeIcon>
                <h3>Log out</h3>
              </div>
            </div>
          </div>
          <div className="page-content">{page}</div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
